export const ROUTES = {
  Chat: {
    Root: '/chat'
  },
  OAuth: {
    AuthCallback: '/:type/oauth2/finish'
  },
  Modal: {
    Documents: '/modal/documents',
    Connections: '/modal/connections',
    Personalization: '/modal/personalization',
    DownloadChat: '/modal/download/chat',
    Memory: '/modal/memory',
    AgentTasks: '/modal/agent-tasks',
    MsgInspector: '/modal/msg-inspector/:msgId'
  },
  System: {
    Error503: '/system/503'
  }
};
